"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogSurface: function() {
        return _index.DialogSurface;
    },
    dialogSurfaceClassNames: function() {
        return _index.dialogSurfaceClassNames;
    },
    renderDialogSurface_unstable: function() {
        return _index.renderDialogSurface_unstable;
    },
    useDialogSurfaceContextValues_unstable: function() {
        return _index.useDialogSurfaceContextValues_unstable;
    },
    useDialogSurfaceStyles_unstable: function() {
        return _index.useDialogSurfaceStyles_unstable;
    },
    useDialogSurface_unstable: function() {
        return _index.useDialogSurface_unstable;
    }
});
const _index = require("./components/DialogSurface/index");
